import React from 'react';

import { TeamIcon, UserSparkleIcon } from '@modernloop/shared/icons';

import { DynamicAudience } from 'src/generated/mloop-graphql';

export enum DynamicAudienceChipIconVariant {
  Error = 'error',
  Primary = 'primary',
  Inherit = 'inherit',
}

/**
 * i18next translate function. Typed locally (rather than importing `TFunction`
 * from `i18next`) because app-client only depends on i18next transitively via
 * `@modernloop/i18n` — mirrors the pattern in `mloop-shared`'s `getTimezoneLabel`.
 */
type TranslateFn = (key: string) => string;

export const getSmartOptionLabel = (type: DynamicAudience, t: TranslateFn) => {
  switch (type) {
    case DynamicAudience.TaskAssignee:
      return t('hiring-dashboard-common:common.smartOption.taskAssignee');
    case DynamicAudience.TaskCreator:
      return t('hiring-dashboard-common:common.smartOption.taskCreator');
    case DynamicAudience.TaskSubscribers:
      return t('hiring-dashboard-common:common.smartOption.taskSubscribers');
    case DynamicAudience.CandidateCoordinator:
      return t('hiring-dashboard-common:common.smartOption.candidateCoordinator');
    case DynamicAudience.CandidateRecruiter:
      return t('hiring-dashboard-common:common.smartOption.candidateRecruiter');
    case DynamicAudience.CandidateSourcer:
      return t('hiring-dashboard-common:common.smartOption.candidateSourcer');
    case DynamicAudience.CandidatesPreviousInterviewers:
      return t('hiring-dashboard-common:common.smartOption.candidatesPreviousInterviewers');
    case DynamicAudience.JobRecruiters:
      return t('hiring-dashboard-common:common.smartOption.jobRecruiters');
    case DynamicAudience.JobCoordinators:
      return t('hiring-dashboard-common:common.smartOption.jobCoordinators');
    case DynamicAudience.JobSourcers:
      return t('hiring-dashboard-common:common.smartOption.jobSourcers');
    case DynamicAudience.JobHiringManagers:
      return t('hiring-dashboard-common:common.smartOption.jobHiringManagers');
    case DynamicAudience.DebriefAttendees:
      return t('hiring-dashboard-common:common.smartOption.debriefAttendees');
    case DynamicAudience.InterviewersOnSchedule:
      return t('hiring-dashboard-common:common.smartOption.interviewersOnSchedule');
    default:
      return '';
  }
};

export const getDacIcon = (type: DynamicAudience, variant: DynamicAudienceChipIconVariant) => {
  switch (type) {
    case DynamicAudience.TaskAssignee:
    case DynamicAudience.TaskCreator:
    case DynamicAudience.CandidateRecruiter:
    case DynamicAudience.CandidateCoordinator:
    case DynamicAudience.CandidateSourcer:
      return <UserSparkleIcon color={variant} />;
    case DynamicAudience.TaskSubscribers:
    case DynamicAudience.CandidatesPreviousInterviewers:
    case DynamicAudience.DebriefAttendees:
    case DynamicAudience.JobCoordinators:
    case DynamicAudience.JobSourcers:
    case DynamicAudience.JobRecruiters:
    case DynamicAudience.JobHiringManagers:
    case DynamicAudience.InterviewersOnSchedule:
      return <TeamIcon color={variant} />;
    default:
      return <></>;
  }
};
